export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_DATA = 'GET_PROJECTS_DATA';
export const GET_PROJECTS_ERROR = 'GET_PROJECTS_ERROR';

export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_DATA = 'GET_PROJECT_DATA';
export const GET_PROJECT_ERROR = 'GET_PROJECT_ERROR';

export const ADD_PROJECT = 'ADD_PROJECT';
export const PROJECT_ADDED = 'PROJECT_ADDED';

export const SWAP_TOKEN_ERROR = 'SWAP_TOKEN_ERROR';
export const SWAP_TOKEN_MODAL = 'SWAP_TOKEN_MODAL';

export const SET_PROJECT_DATA = 'SET_PROJECT_DATA';

export const GET_MERCURX_PROJECT_REQUEST = 'GET_MERCURX_PROJECT_REQUEST';
export const GET_MERCURX_PROJECT_DATA = 'GET_MERCURX_PROJECT_DATA';
export const GET_MERCURX_PROJECT_ERROR = 'GET_MERCURX_PROJECT_ERROR';
